import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  moduleId: module.id,
  templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {
  loading = false;
  error = '';
  loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });
  submitted = false;

  constructor(private router: Router, private authenticationService: AuthenticationService) {
    //
  }

  onSubmit({value, valid}) {
    this.submitted = true;

    if (valid) {
      this.loading = true;

      this.authenticationService.logIn(value.username, value.password).subscribe(result => {
        this.loading = false;

        if (result === true) {
          if (this.authenticationService.userRole() === 'manufacturer') {
            this.router.navigate(['/clients']);
          } else {
            this.router.navigate(['/dashboard']);
          }
        } else {
          // logging in failed
          this.error = 'Wrong email address or password. Please contact the administrator for support.';
          this.loading = false;
        }
      }, (e) => {
        this.error = 'Wrong email address or password. Please contact the administrator for support.';
        this.loading = false;
      });
    }
  }

  ngOnInit() {
    // reset login status
    this.authenticationService.logOut();
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts